module.exports = __webpack_public_path__ + "media/assets/books-glasses-round-80aa0e9a0c0e6cb840e9998873a6e36a.svg";